import React, { useEffect, useState } from 'react';
import Widget from '../../../components/Widget';
import FuelConsumptionRateBarLineChart from '../../../components/Chart/FuelConsumptionRateBarLine';

function FuelConsumptionRate(props) {
    const [idleFuelRate, setIdleFuelRate] = useState(0);
    const [standardFuelRate, setStandardFuelRate] = useState(null);

    useEffect(() => {
        if (props.assetData) {
            const idleRate = props.assetData.assetModel && props.assetData.assetModel.idealFuelConsumptionRate || 0;
            const standardRate = props.assetData.assetModel && props.assetData.assetModel.standardFuelConsumptionRate || [];
            setIdleFuelRate(idleRate)
            setStandardFuelRate(standardRate)
        }
    }, [props.assetData]);

    return (
        <Widget>
            <FuelConsumptionRateBarLineChart selectedGroup={props.selectedGroup} loading={props.loading} assetData={props.assetData} data={props.data} idleFuelRate={idleFuelRate}
                standardFuelRate={standardFuelRate} />
        </Widget>
    );
}

export default FuelConsumptionRate;
